import { lazy } from 'react';
import { centerModalOption } from '../../appComponents/ModalWrapper';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import { SharePageProps } from './SharePage';

const SharePageContent = lazy(
  () => import('./components/SharePageContent.web'),
);

export const SharePage = wrapLazyNavigatorScreen((props: SharePageProps) => {
  return <SharePageContent {...props}></SharePageContent>;
}, centerModalOption);
